"use client";

import { cn } from "@frontend/shared/lib/utils";
import { ArrowDown } from "lucide-react";

export function ShopNowButtonComponent({
  style,
  isBoutique = false,
}: { style: string; isBoutique?: boolean }) {
  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <button
      type="button"
      className={cn(
        " bg-white w-fit flex gap-2 p-5 rounded-full px-7 max-w-[180px]  justify-center",
        style,
      )}
      onClick={() => {
        scrollToElement("shopNowScroll");
      }}
    >
      <p className={cn(isBoutique ? "text-white" : "text-black")}>Shop now</p>{" "}
      <ArrowDown color={isBoutique ? "white" : "black"} />
    </button>
  );
}
